import WPHeading from "./WPHeading";

export default WPHeading;
